import { IonButton, IonButtons, IonCard, IonCheckbox, IonCol, IonGrid, IonIcon, IonInput, IonItem, IonLabel, IonMenuButton, IonRow, IonSegment, IonSegmentButton, IonSelect, IonSelectOption } from '@ionic/react'
import { search, starOutline, swapVerticalOutline } from 'ionicons/icons'
import { useCallback, useMemo, useState } from 'react'
import { LineSeparator } from '../../components/Atoms/LineSeparator/LineSeparator'
import { TitleForm } from '../../components/Atoms/TitleForm'
import { WrapperApp } from '../../components/Organisms/WrapperApp/WrapperApp'
import { StatusProduct, type Product } from '../../models/product'
import ProductItem from '../CommonComponentsInPages/ProductItem/ProductItem'
import { HeaderDashboard } from '../Dashboard/components/HeaderDashboard'
import { ButtonsHeader } from './components/ButtonsHeader/ButtonsHeader'

const LIST_OF_PRODUCT: Product[] = [
  {
    id: 1,
    image: 'https://oechsle.vteximg.com.br/arquivos/ids/5394668-1000-1000/image-46d4599129454a80bc0c67ba07bee3a0.jpg?v=637698416053830000',
    name: 'Microhondas marca daka 3km generico',
    status: StatusProduct.ACTIVE,
    inventary: '3 en stock',
    type: 'Físico',
    seller: 'Daka. C.A'
  },
  {
    id: 2,
    image: 'data:image/jpeg;base64,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',
    name: 'Ventilador de pedestal 18 pulgadas 3 Aspas Fortunne',
    status: StatusProduct.ACTIVE,
    inventary: '4 en stock',
    type: 'Físico',
    seller: 'Makro'
  },
  {
    id: 3,
    image: 'https://http2.mlstatic.com/D_NQ_NP_850654-MCO69550492881_052023-O.webp',
    name: 'Televisor Samsung Smart 60 pulgadas / Serie: 6 - PC Tecnología',
    status: StatusProduct.RESERVED,
    inventary: 'Inventario no rastreado',
    type: 'Físico',
    seller: 'Daka. C.A'
  }
]

export function Products () {
  const [productsSelected, setProductsSelected] = useState<Product[]>([])
  const [chekedAllProducts, setChekedAllProducts] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [selectSellerValue, setSelectSellerValue] = useState('')
  const [segmentStatus, setSegmentStatus] = useState<StatusProduct>(StatusProduct.ALL)

  const handleSearchValue = (e: any) => {
    setSearchValue(e?.target?.value)
  }

  const handleSelectAllProducts = useCallback((e: any) => {
    console.log('handleSelectAllProducts')
    setChekedAllProducts(Boolean(e?.detail?.checked))
    const cheked = Boolean(e?.detail?.checked)
    if (!cheked) {
      setProductsSelected([])
      return
    }
    setProductsSelected(LIST_OF_PRODUCT)
  }, [])

  const filteredProducts = useMemo(() => {
    return searchValue !== null
      ? segmentStatus === StatusProduct.ALL
        ? LIST_OF_PRODUCT
          .filter(product => product.name.toLowerCase().includes(searchValue.toLowerCase()))
          .filter(product => product.seller.toLowerCase().includes(selectSellerValue.toLowerCase()))
        : LIST_OF_PRODUCT
          .filter(product => product.name.toLowerCase().includes(searchValue.toLowerCase()))
          .filter(product => product.seller.toLowerCase().includes(selectSellerValue.toLowerCase()))
          .filter(product => product.status.toLowerCase() === segmentStatus.toLowerCase())
      : LIST_OF_PRODUCT
  }, [LIST_OF_PRODUCT, searchValue, selectSellerValue, segmentStatus])

  return (
    <>
    <WrapperApp
      pageName="Productos"
      hiddenAvatar={true}
      renderButtons={() => (
        <>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <HeaderDashboard />
        </>
      )}
    >
      <IonCard className="box ion-padding">
        <div>
          <TitleForm title="Productos" customClass="ion-margin-start ion-margin-bottom" />
          <ButtonsHeader />
        </div>
        <LineSeparator />

        <IonSegment value={segmentStatus} scrollable onIonChange={e => { setSegmentStatus(e.detail.value as StatusProduct) }} className='ion-padding-horizontal'>
          <IonSegmentButton value={StatusProduct.ALL}><IonLabel>Todos</IonLabel></IonSegmentButton>
          <IonSegmentButton value={StatusProduct.ACTIVE}><IonLabel>Activos</IonLabel></IonSegmentButton>
          <IonSegmentButton value={StatusProduct.RESERVED}><IonLabel>Reservados</IonLabel></IonSegmentButton>
          <IonSegmentButton value={StatusProduct.ARCHIVED}><IonLabel>Archivados</IonLabel></IonSegmentButton>
        </IonSegment>

        <IonGrid>
          <IonRow className='ion-justify-content-between ion-justify-items-between ion-align-items-center ion-margin-bottom'>
            <IonCol class='flex ion-justify-content-start' size='6'>
              <IonItem fill='solid' style={{ width: '100%' }}>
                <IonIcon slot="start" icon={search} />
                <IonInput name='search' placeholder='Buscar' type='search' value={searchValue} onIonChange={handleSearchValue} />
              </IonItem>
            </IonCol>
            <IonCol class='flex ion-justify-content-center'>
              <IonItem>
               <IonLabel position="floating">Por vendedor</IonLabel>
                <IonSelect name='seller' placeholder="Vendedor" value={selectSellerValue} onIonChange={e => { setSelectSellerValue(e.detail.value) }}>
                  <IonSelectOption value="">Todos</IonSelectOption>
                  <IonSelectOption value="Daka. C.A">Daka. C.A</IonSelectOption>
                  <IonSelectOption value="Makro">Makro</IonSelectOption>
                </IonSelect>
              </IonItem>
            </IonCol>
            <IonCol class='flex ion-justify-content-center'>
              <IonButton shape="round" fill="outline" size='small'>
                <IonIcon slot="start" icon={starOutline} />
                <span style={{ fontSize: '12px' }}>Favoritos</span>
              </IonButton>
            </IonCol>
            <IonCol class='flex ion-justify-content-center'>
              <IonButton color="secondary" shape="round" fill="outline" size='small'>
                <IonIcon slot="start" icon={swapVerticalOutline} />
                <span style={{ fontSize: '12px' }}>Ordenar</span>
              </IonButton>
            </IonCol>
          </IonRow>
          <IonRow className='ion-justify-content-start ion-align-items-center'>
            <IonCol>
              <IonCheckbox name='all-cheked' checked={chekedAllProducts} value={chekedAllProducts} onIonChange={(e) => { handleSelectAllProducts(e) }} />
            </IonCol>
            <IonCol><IonLabel>Producto</IonLabel></IonCol>
            <IonCol>Status</IonCol>
            <IonCol>Inventario</IonCol>
            <IonCol>Tipo</IonCol>
            <IonCol>Vendedor</IonCol>
          </IonRow>
          {filteredProducts.map(product => {
            const productIsSelected = productsSelected.some(p => p.id === product.id)
            return (
              <ProductItem
                key={product.id}
                product={product}
                productIsSelected={productIsSelected}
                setProductsSelected={setProductsSelected}
              />
            )
          })}
        </IonGrid>
      </IonCard>
    </WrapperApp>
    </>
  )
}
